import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePort, Port } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<Port>
    useData={usePort}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
